export enum PaymentSystems {
  IDRAM = '10',
  ARCA = '12',
}
